const INITIAL_BASIC_INFO = {
  name: '',
  displayName: '',
  telephone: '',
  email: '',
  company: '',
  projects: [],
  status: '',
  isLocked: false,
  passwordStatus: '',
  source: '',
  contractNumber: ''
};

const USER_TYPE = {
  PLATFORM: 'PLATFORM'
};

export { INITIAL_BASIC_INFO, USER_TYPE };
